import type { BubbleChartCommands, HighlightState } from '@ardoq/bubble-chart';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  panSettle as panSettleAction,
  setCenter as setCenterAction,
  setFocusState,
  setHoverState,
  setScale as setScaleAction,
} from '@ardoq/bubble-chart';
import { ChartWindowState } from '@ardoq/graph';
import { Point } from '@ardoq/math';
import {
  openDetailsDrawer as openDetailsDrawerAction,
  updateDetailsDrawer as updateDetailsDrawerAction,
} from 'appLayout/ardoqStudio/detailsDrawer/actions';
import { ArdoqId } from '@ardoq/api-types';
import { selectComponent as selectComponentAction } from 'streams/components/ComponentActions';
import { CidArgs } from '@ardoq/common-helpers';
import { componentSelectedInQuickExploreMode } from 'traverseOneLevel/actions';
import { noop } from 'lodash';

const updateHoverState = (
  hoverState: HighlightState,
  viewInstanceId: string
) => {
  dispatchAction(setHoverState(hoverState), viewInstanceId);
};

const updateFocusState = (
  focusState: HighlightState,
  viewInstanceId: string
) => {
  dispatchAction(setFocusState(focusState), viewInstanceId);
};

const setCenter = (windowCenter: Point, viewInstanceId: string) => {
  dispatchAction(setCenterAction(windowCenter), viewInstanceId);
};
const setScale = (state: ChartWindowState, viewInstanceId: string) => {
  dispatchAction(setScaleAction(state), viewInstanceId);
};
const panSettle = (viewInstanceId: string) => {
  dispatchAction(panSettleAction(), viewInstanceId);
};

const openDetailsDrawer = (componentId: ArdoqId) => {
  dispatchAction(openDetailsDrawerAction([componentId]));
};

const updateDetailsDrawer = (componentId: ArdoqId) => {
  dispatchAction(updateDetailsDrawerAction([componentId]));
};

const selectComponent = (args: CidArgs) => {
  dispatchAction(selectComponentAction(args));
};

const selectComponentInQuickExploreMode = (componentId: ArdoqId) => {
  dispatchAction(componentSelectedInQuickExploreMode(componentId));
};

const baseBubbleChartCommands = {
  updateHoverState,
  updateFocusState,
  setCenter,
  setScale,
  panSettle,
  selectComponent,
};

export const workspaceModeBubbleChartCommands: BubbleChartCommands = {
  ...baseBubbleChartCommands,
  onBubbleClick: noop,
  onBubbleDoubleClick: noop,
};

export const createViewpointModeBubbleChartCommands = (
  isQuickExploreSelectionEnabled: boolean
): BubbleChartCommands => ({
  ...baseBubbleChartCommands,
  onBubbleClick: updateDetailsDrawer,
  onBubbleDoubleClick: isQuickExploreSelectionEnabled
    ? selectComponentInQuickExploreMode
    : openDetailsDrawer,
});
